import React from 'react';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { Users, Target, Shield, Zap } from 'lucide-react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-page">
      <SEO
        title="About Us"
        description="Learn more about FastInvoice, India's smartest invoicing and billing platform."
      />

      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="bg-glow glow-top-right"></div>
        <div className="bg-glow glow-bottom-left"></div>
        <div className="about-hero-content">
          <h1>About <span className="text-gradient">FastInvoice</span></h1>
          <p>We are on a mission to simplify invoicing and billing for millions of Indian businesses.</p>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="about-stats-section">
        <div className="stats-grid">
          <div className="stat-card">
            <h3>10K+</h3>
            <p>Active Users</p>
          </div>
          <div className="stat-card">
            <h3>₹100Cr+</h3>
            <p>Invoices Processed</p>
          </div>
          <div className="stat-card">
            <h3>99.9%</h3>
            <p>Uptime</p>
          </div>
          <div className="stat-card">
            <h3>24/7</h3>
            <p>Support</p>
          </div>
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="core-values-section">
        <h2>Our Core Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon"><Shield size={24} /></div>
            <h4>Trust & Security</h4>
            <p>We prioritize the security of your financial data with enterprise-grade encryption.</p>
          </div>
          <div className="value-card">
            <div className="value-icon"><Zap size={24} /></div>
            <h4>Speed & Efficiency</h4>
            <p>Lightning-fast invoice generation so you can focus on growing your business.</p>
          </div>
          <div className="value-card">
            <div className="value-icon"><Target size={24} /></div>
            <h4>Customer First</h4>
            <p>Every feature we build is designed to solve real problems for our users.</p>
          </div>
          <div className="value-card">
            <div className="value-icon"><Users size={24} /></div>
            <h4>Collaboration</h4>
            <p>Built for teams, enabling seamless financial operations across your organization.</p>
          </div>
        </div>
      </section>

      {/* TEAM SECTION Placeholder */}
      {/* <section className="team-section">
        <h2>Meet the Team</h2>
        <p className="team-sub">The passionate people behind FastInvoice.</p>
        <div className="team-grid">
          {[1, 2, 3, 4].map((member) => (
            <div key={member} className="team-card">
              <div className="team-avatar"></div>
              <h4>Team Member {member}</h4>
              <p>Position Title</p>
            </div>
          ))}
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default AboutUs;
